import { PremiumBackground } from './PremiumBackground';

interface DesktopSplashProps {
  progress: number;
}

export function DesktopSplash({ progress }: DesktopSplashProps) {
  const progressLabel = Math.round(progress);

  return (
    <div className="cs-premium-desktop cs-premium-desktop--splash">
      <PremiumBackground subtle />

      <div className="cs-premium-desktop__shell">
        <section className="cs-premium-desktop__panel">
          <div className="cs-premium-desktop__brand">
            <span className="cs-premium-desktop__brand-mark" aria-hidden>
              <img src="/brand/logo-64.webp" alt="" width={28} height={28} draggable={false} />
            </span>
            <span className="cs-premium-desktop__brand-name">CozzySIM</span>
          </div>

          <div className="cs-premium-desktop__copy">
            <p className="cs-premium-desktop__eyebrow">Travel eSIM</p>
            <h1 className="cs-premium-desktop__title">CozzySIM</h1>
            <p className="cs-premium-desktop__subtitle">Fast eSIM for Travel</p>
          </div>

          <div className="cs-premium-desktop__loader">
            <div className="cs-premium-desktop__loader-head">
              <span>Loading experience</span>
              <strong>{progressLabel}%</strong>
            </div>
            <div className="cs-premium-desktop__loader-track">
              <div
                className="cs-premium-desktop__loader-bar"
                style={{ width: `${progress}%` }}
              />
            </div>
          </div>
        </section>

        <section className="cs-premium-desktop__visual" aria-hidden>
          <div className="cs-premium-desktop__orbit">
            <div className="cs-premium-desktop__orbit-ring cs-premium-desktop__orbit-ring--outer" />
            <div className="cs-premium-desktop__orbit-ring cs-premium-desktop__orbit-ring--inner" />
            <div className="cs-premium-desktop__orbit-glow" />
            <img
              src="/brand/logo-256.webp"
              alt=""
              className="cs-premium-desktop__hero-image"
              width={360}
              height={360}
              draggable={false}
            />
          </div>
        </section>
      </div>
    </div>
  );
}
